import Action, { SavedLoginAction } from "@my-dld/actions";
import { AnyAction } from "redux";
import { SupportedLanguage } from "@eres/core";
import { IUser } from "@10x/sso";
import { MetricSystem, UnitSystem } from "@my-dld/utils/UnitUtils";
import { setTrackingUserId } from "@my-dld/utils/Analytics";
import { DataViewType, ListView } from "@my-dld/utils/UIUtils";
import { TabuVIPCategory } from "@10x/sso/TabuProfile";
import { dispatch } from "@my-dld/utils/StoreUtils";
import Actions from "@my-dld/actions";

interface SavedLogin {
	eid?: string;
	ownerEid?: string;
}

export interface UserState {
	RequiredUserVersion: number,
	user?: IUser; //do not access directly this for storage only no methods available use getUser methods in utils/User
	vipCategory?: TabuVIPCategory;
	token?: string;
	guestToken?: string;
	language: SupportedLanguage;
	unit: UnitSystem;
	savedLogin?: SavedLogin;
	tenantId?: number,
	showProfileUpdated?: boolean;
	viewType: DataViewType,
	ownerDashboardViewType: DataViewType;
	isUaePassUser?: boolean;
	application?: any;
	selectedProfileId?: any;
	showNDA?: boolean;
}

export const defaultState: UserState = {
	RequiredUserVersion: 2,
	language: "en",
	unit: MetricSystem,
	viewType: ListView,
	ownerDashboardViewType: ListView,
};

export function UserReducer( state = defaultState, action: AnyAction ): UserState {
	if ( state.savedLogin === undefined ) state.savedLogin = {};
	switch ( action.type ) {
		case Action.USER_LOGGED_IN:
			setTrackingUserId( action.payload.uniqId + "" );
			return { ...state, user: action.payload };
		case Action.USER_LOGGED_OUT:
			setTrackingUserId( undefined );
			return {
				...state,
				user: undefined,
				token: undefined,
				tenantId: undefined,
				vipCategory: undefined,
				isUaePassUser: undefined,
			};
		case Action.LANG_CHANGED:
			return { ...state, language: action.payload };
		case Action.SET_IS_UAE_PASS_USER:
			return { ...state, isUaePassUser: action.payload };
		case Action.SET_APPLICATION:
			return { ...state, application: action.payload };
		case Action.SET_SELETEDPROFILE_ID:
			return { ...state, selectedProfileId: action.payload };
		case Action.SET_SHOW_NDA:
			return { ...state, showNDA: action.payload };
		case Action.TOKEN_CHANGED:
			return { ...state, token: action.payload };
		case Action.GUEST_TOKEN_CHANGED:
			return { ...state, guestToken: action.payload };
		case Action.UNIT_CHANGED:
			return { ...state, unit: action.payload };
		case SavedLoginAction.SAVE_EID:
			return {
				...state, savedLogin: {
					...state.savedLogin,
					eid: action.payload,
				}
			};
		case SavedLoginAction.SAVE_OWNER_EID:
			return {
				...state, savedLogin: {
					...state.savedLogin,
					ownerEid: action.payload,
				}
			};
		case Action.UPDATE_TENANT_ID:
			return { ...state, tenantId: action.payload };
		case Action.SHOW_PROFILE_UPDATED:
			return { ...state, showProfileUpdated: action.payload };
		case Action.VIEW_TYPE_CHANGED:
			return { ...state, viewType: action.payload };
		case Action.OWNER_DASHBOARD_VIEW_TYPE_CHANGED:
			return { ...state, ownerDashboardViewType: action.payload };
		case Action.VIP_CATEGORY_CHANGED:
			return { ...state, vipCategory: action.payload };
		default:
			return state;
	}
}
